import { Outlet } from 'react-router-dom'

import {
  FormsCustomTemplatesFragment,
  SurveyTemplatesPageDocument,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import FormsTemplatesDataCollection from 'modules/forms/components/FormsTemplatesDataCollection'
import {
  type ColumnConfigurations,
  TableColumnType,
} from 'modules/forms/components/FormsTemplatesDataCollection/properties/definitions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SurveyTemplates = () => {
  const { loading: loadingPage, data, error } = useQuery(SurveyTemplatesPageDocument)
  const authorized = data?.trainings._policies.trainingsAccessManagementSpace.can
  const { navigation } = useNavigation()
  const columns = [
    TableColumnType.Name,
    TableColumnType.FormType,
    TableColumnType.Status,
    TableColumnType.Author,
  ]

  const configurations: ColumnConfigurations = {
    [TableColumnType.FormType]: {
      valueMapping: {
        satisfaction: i18n.t('forms.custom_templates.data_collection.type_values.satisfaction'),
        effectiveness: i18n.t('forms.custom_templates.data_collection.type_values.effectiveness'),
        knowledge: i18n.t('forms.custom_templates.data_collection.type_values.knowledge'),
      },
      colorMapping: {
        satisfaction: 'yellow',
        effectiveness: 'malibu',
        knowledge: 'purple',
      },
    },
    [TableColumnType.Status]: {
      valueMapping: {
        draft: i18n.t('forms.custom_templates.data_collection.status_values.draft'),
        active: i18n.t('forms.custom_templates.data_collection.status_values.published'),
      },
      colorMapping: {
        draft: 'neutral',
        active: 'positive',
      },
    },
  }

  const itemUrl = (item: FormsCustomTemplatesFragment) => {
    return navigation.trainings.list.surveyTemplates.templateDetails.edit.fullPath({
      templateId: item.id,
    })
  }

  return (
    <ResponsivePage.Body variant="full" authorized={authorized} loading={loadingPage} error={error}>
      <FormsTemplatesDataCollection
        resourceType={'Trainings::Training'}
        columns={columns}
        configurations={configurations}
        routes={{
          create: navigation.trainings.list.surveyTemplates.list.newTemplate.fullPath(),
        }}
        itemUrl={itemUrl}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default SurveyTemplates
